module.exports = __webpack_public_path__ + "static/media/TracyBrown_BallMill_Simulator.e373b6bf.zip";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zip/simulator/TracyBrown_BallMill_Simulator.zip
// module id = 426
// module chunks = 0